import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import roleSaga from './sagas';
import reducer from './reducer';

export function RoleDetails({ children }) {
  useInjectSaga({ key: 'roleDetails', saga: roleSaga });
  useInjectReducer({ key: 'roleDetails', reducer });

  return React.Children.only(children);
}

RoleDetails.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withRole } from './withRole';
export default compose(withConnect, memo)(RoleDetails);
